export default __webpack_public_path__ + "static/media/left.366d8111.png";